import { render } from "./nfts.vue?vue&type=template&id=16a8cbd9"
import script from "./nfts.vue?vue&type=script&lang=js"
export * from "./nfts.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__